// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import axios from "axios"


const productsPromise: Promise<Product[]> = (async () => {
  const response = await axios.get('/assets/apple.json')
  return response.data
})()


interface Product {
  name: string
  sku: string
}


class ProductRepository {
  private products: Product[]

  constructor() {
    this.products = []
    productsPromise.then((products) => { this.products = products})
  }

  async list(): Promise<Product[]> {
    await productsPromise
    return this.products
  }
}


export { ProductRepository }